<template>
    <div class="footer-setup">
        <div class="progress-wrapper">
            <div class="progress" :style="'width:' + progressPercentage"></div>
        </div>

        <div class="d-flex justify-content-between position-relative">
            <div>
                <basic-button
                    v-if="step > 1"
                    cls="btn-secondary btn-next"
                    icon="fi-rr-angle-small-left"
                    :text="trans('general.setup.previous')"
                    @click="prevStep"/>
            </div>

            <basic-button
                :disabled="nextDisabled"
                cls="btn-primary btn-next"
                :text="buttonText"
                icon="fi-rr-angle-small-right"
                icon-position="right"
                @click="nextStep"/>
        </div>
    </div>
</template>

<script>
import BasicButton from "../../../theme/atoms/BasicButton.vue";

export default {
    name: "SetupFooter",
    components: {
        BasicButton
    },
    props : {
        step: {
            type: Number,
            default: 1
        },
        totalSteps: {
            type: Number,
            default: 6
        },
        nextDisabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            showBackStep: false,
            buttonInitial: trans('general.setup.next'),
            buttonText: '',
        }
    },
    computed: {
        progressPercentage() {
            let percentage = (this.step + 1) * (100 / this.totalSteps);
            return (percentage === 0 ? 5 : (percentage > 99 ? 97 : percentage)) + '%';
        }
    },
    methods: {
        prevStep() {
            this.$emit('prevStep');
        },
        nextStep() {
            this.$emit('nextStep');
        },
        setButtonText(lastUnfinishedStep = false) {
            if(typeof lastUnfinishedStep === 'string') {
                this.buttonText = lastUnfinishedStep
                return;
            }

            if(lastUnfinishedStep) {
                this.buttonText = trans('general.setup.finish_setup');
            } else {
                this.buttonText = this.buttonInitial
            }
        },
    },
    mounted() {
        this.setButtonText();
    }
}
</script>
